// libraries
import React from 'react'
import clsx from 'clsx'

// svg
import { UxSpinner } from '/react4xp/components/Svg/Ux'

// prop types
interface Props {
    small?: boolean
    style?: 'solid' | 'hollow'
    color?: 'primary' | 'secondary' | 'tertiary'
    href?: string
    target?: boolean | '_self' | '_blank'
    type?: 'button' | 'submit'
    className?: string
    children?: React.ReactNode
    onClick?: (e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement>) => void
    disabled?: boolean
    loading?: boolean
}

export default function Button({
    small,
    style,
    color,
    href,
    target,
    type,
    children,
    className,
    onClick,
    disabled,
    loading,
    ...rest
}: Props) {

    // check if the element is a link or a button based on the presence of href
    const Element = href ? 'a' : 'button'

    // Automatically disable when loading
    const isDisabled = disabled || loading

    const resolvedTarget =
        target === '_blank' || target === true
            ? '_blank'
            : target === '_self' || target === false
              ? undefined
              : undefined

    const elementProps = {
        href: href || null,
        target: resolvedTarget,
        rel: resolvedTarget === '_blank' ? 'noopener noreferrer' : undefined,
        type: Element === 'button' ? type : undefined,
        disabled: Element === 'button' ? isDisabled : undefined,
        onClick: onClick || undefined,
        className: clsx(
            'button',

            // styles
            style === 'solid' && 'button--solid',
            style === 'hollow' && 'button--hollow',

            // colors
            color === 'primary' && 'button--primary',
            color === 'secondary' && 'button--secondary',
            color === 'tertiary' && 'button--tertiary',

            // sizes
            small && 'button--small',

            type === 'submit' && 'button--submit',
            loading && 'button--loading',
            isDisabled && 'button--disabled',
            className
        ),
        ...rest
    }

    return (
        <Element {...elementProps}>
            {loading && (
                <span className='button__spinner'>
                    <UxSpinner />
                </span>
            )}
            {type === 'submit' ? (
                <span className='relative z0'>
                    {children}
                </span>
            ) : (
                children
            )}
        </Element>
    )
}